// extracted by css-extract-rspack-plugin
export default {"PreviewButton":"toyyU","PreviewButtonIcon":"gwRWw"};